import { useTranslation } from "react-i18next";

// styles
require("./TopBarWithBreadCrumb.css");

interface Props {
  setPopupData: any;
  text: string;
  enabled?: boolean;
  handleAction?:any;
}

const AddButtonInTopBar = (props: Props) => {
  const { t } = useTranslation();
  if (props.enabled) {
    return (
      <a
        className="btn btn-sm btn-primary"
        onClick={() => {
          props.setPopupData({ visible: true, id: undefined });

          if (props.handleAction){
            props.handleAction();
          }
        }}
        style={{ backgroundColor: " #55acee;" }}
        role="button"
      >
        <i className="fas fa-plus-circle me-2"></i>
        {props.text}
      </a>
    );
  }
  else {
    return <></>
  }
};

export default AddButtonInTopBar;
